// Tidspunkt i «Nytt oppdrag» kan bare velges på hele og halve timer.
// Verdier lagres som lokal streng «YYYY-MM-DDTHH:mm» (samme format som datetime-local).

const pad = n => String(n).padStart(2, '0');

export const HALF_HOUR_TIMES = Array.from({ length: 48 }, (_, i) =>
  `${pad(Math.floor(i / 2))}:${i % 2 ? '30' : '00'}`);

export function toLocalInput(d) {
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}T${pad(d.getHours())}:${pad(d.getMinutes())}`;
}

// Neste hele/halve time strengt etter «nå».
export function nextHalfHourLocal(now = new Date()) {
  const d = new Date(now.getTime());
  d.setSeconds(0, 0);
  d.setMinutes(d.getMinutes() < 30 ? 0 : 30); // rund ned til forrige halvtime…
  d.setTime(d.getTime() + 30 * 60 * 1000);     // …og gå én halvtime frem
  return toLocalInput(d);
}

export function splitLocal(value) {
  if (!value || !value.includes('T')) return { date: '', time: '' };
  const [date, time] = value.split('T');
  return { date, time: time.slice(0, 5) };
}

export function joinLocal(date, time) {
  return date && time ? `${date}T${time}` : '';
}

// null = OK. Ellers 'empty' | 'invalid' (ikke :00/:30) | 'past'.
export function validateHalfHour(value, now = new Date()) {
  if (!value) return 'empty';
  const { time } = splitLocal(value);
  if (!HALF_HOUR_TIMES.includes(time)) return 'invalid';
  const d = new Date(value);
  if (Number.isNaN(d.getTime())) return 'invalid';
  return d.getTime() < now.getTime() ? 'past' : null;
}

// «Lørdag 3. okt · 08:00»
export function formatLocalNb(value) {
  const { date, time } = splitLocal(value);
  if (!date || !time) return '';
  const d = new Date(value);
  if (Number.isNaN(d.getTime())) return '';
  const weekday = d.toLocaleDateString('nb-NO', { weekday: 'long' });
  const month = d.toLocaleDateString('nb-NO', { month: 'short' }).replace(/\.$/, '');
  return `${weekday.charAt(0).toUpperCase()}${weekday.slice(1)} ${d.getDate()}. ${month} · ${time}`;
}

export function formatDateNb(value) {
  const full = formatLocalNb(value);
  return full ? full.split(' · ')[0] : '';
}
